module.exports = __webpack_public_path__ + "static/media/GrayLines.01e150da.svg";